import { PortableTextListComponent } from '@portabletext/react'
import classNames from 'classnames'
import React from 'react'
import { commonListClassName } from './DefaultListSerializer'

export const FactboxListSerializer: PortableTextListComponent = ({ children, value }) =>
  value.listItem === 'bullet' ? (
    <ul
      className={classNames(
        commonListClassName,
        'bullet align-middle text-secondary-dark'
      )}
    >
      {children}
    </ul>
  ) : (
    <ol className="fact-box__list-decimal text-secondary-dark">{children}</ol>
  )
